import { SpecifiedTradeAllowanceChargeCode } from '@dave/types/dist/proto/einvoicing/main';
import { isArray } from 'chart.js/helpers';
import { isNotNullOrUndefined } from '../../helper/helper';
import { LedgerImportType,Maybe } from '../graphql-types';
import { BackendDate,FrontendDate } from '../helper/backend-frontend-conversion.helper';
import {
AccountsReceivableLedgerEntity,
AccountsReceivableLedgerTypeEnum,
financialRound
} from './accounts-receivable-ledger.entity';
import { BusinessVolumeCostStateEnum } from './business-volume.entity';
import { TaxTypes } from './customer.entity';
import { PartnerOfficeAdditionalData } from './partnerOffice.entity';
import {InvoiceItemGRPC, LedgerImport, PaymentItemGRPC} from "@dave/types/dist/proto/accounting/ledgerImport";
import {GetTimeFromTimestamp} from "@dave/types";
import {TaxType} from "@dave/types/dist/proto/accounting/taxType";

export enum LedgerImportBreakPageModeEnum {
    All = 'all',
    FirstLayerTitle = 'firstLayerTitle',
    Title = 'title'
}
export enum DocumentStatusEnum {
    Failed = 'Failed',
    Finished = 'Finished',
    None = 'None',
    Queued = 'Queued',
    Running = 'Running'
}

export type LedgerImportSpecifiedTradeAllowanceChargeCode = SpecifiedTradeAllowanceChargeCode;
export interface LedgerImportARLCalculationPreChargeByType {
    arlType: AccountsReceivableLedgerTypeEnum;
    percentage: number;
}
export interface LedgerImportARLSurchargesByType {
    arlType: AccountsReceivableLedgerTypeEnum;
    percentage: number;
}
export type LedgerImportInvoiceItem = {
    amountBrutto?: number;
    amountNetto?: number;
    invoiceDate?: Date;
    invoiceNo?: string;
    ledgerImportId?: number;
    name?: string;
};
export type LedgerImportPaymentItem = {
  bVType?: Maybe<BusinessVolumeCostStateEnum>;
  businessVolumeId?: number;
  businessVolumeNo?: string;
  payedAmountBrutto?: number;
  payedAmountNetto?: number;
  paymentDate?: Date;
};
export interface LedgerImportAllowanceCharge {
    // level: number;
    /**
     * 10% -> 0.1
     */
    percentage?: number;
    amount?: number;
    reasonCode?: LedgerImportSpecifiedTradeAllowanceChargeCode;
    customReason?: string;
    usePercentage?: boolean;
}
export interface GabeIds {
    GabeBase?: number;
    GabeCostEstimate?: number;
    GabeOfferRequest?: number;
    GabeOfferRequestWQ?: number;
    GabeOfferRequestP?: number;
    GabeOfferRequestWQP?: number;
    GabeOfferRequestD?: number;
    GabeOfferRequestWQD?: number;
    GabeOffer?: number;
    GabeOfferWQ?: number;
    GabeOfferP?: number;
    GabeOfferWQP?: number;
    GabeOfferD?: number;
    GabeOfferWQD?: number;
    GabeSideOffer?: number;
    GabeGrant?: number;
    GabePriceRequest?: number;
    GabePriceOffer?: number;
    GabeOrder?: number;
    GabeOrderResponse?: number;
    Oenorm?: number;
    OenormWQ?: number;
    Ugl?: number;
    UglWQ?: number;
    OenormDTA?: number;
    OenormWQDTA?: number;
}

export enum LedgerImportTaxTypeEnum {
    Five = 'five',
    Kleinunternehmer = 'kleinunternehmer',
    Nineteen = 'nineteen',
    Photovoltaik = 'photovoltaik',
    ReverseCharge = 'reverse_charge',
    Seven = 'seven',
    Sixteen = 'sixteen',
    Twenty = 'twenty',

    ReverseChargeLuksch = 'reverse_charge_Luksch',
    Paragraph_19aLuksch = 'paragraph_19a_luksch',
    Paragraph_13bLuksch = 'paragraph_13b_luksch',
    BauleistungLuksch = 'bauleistung_luksch',
    InnergemeinschaftlicheLieferungLuksch = 'innergemeinschaftliche_lieferung_luksch',
}
export const getLedgerImportTaxTypeName = (taxType: LedgerImportTaxTypeEnum, partnerId: number) => {
    const isLuksch = partnerId === window['env']['luksch_partner_id'];
    const isLukschDe = partnerId === window['env']['luksch_partner_id2'];

    switch (taxType) {
        case LedgerImportTaxTypeEnum.Twenty:
            return '20%';
        case LedgerImportTaxTypeEnum.Nineteen:
            return '19%';
        case LedgerImportTaxTypeEnum.Sixteen:
            return '16%';
        case LedgerImportTaxTypeEnum.Seven:
            return '7%';
        case LedgerImportTaxTypeEnum.Five:
            return '5%';
        case LedgerImportTaxTypeEnum.ReverseCharge:
            return '0% Reverse-Charge (§ 13b UStG)'; // wird für luksch raus gefiltert
        case LedgerImportTaxTypeEnum.Photovoltaik:
            return isLuksch ? '0% Photovoltaikanlage' : '0% Photovoltaikanlagen (§ 12 Abs. 3 UStG)';
        case LedgerImportTaxTypeEnum.Kleinunternehmer:
            return '0% Kleinunternehmer (§ 19 UStG)';
        case LedgerImportTaxTypeEnum.ReverseChargeLuksch:
            return "0% Reverse-Charge";
        case LedgerImportTaxTypeEnum.Paragraph_19aLuksch:
            return "0% §19a"; // todo 0% §19 Bauleistung
        case LedgerImportTaxTypeEnum.Paragraph_13bLuksch:
            return "0% §13b";

        case LedgerImportTaxTypeEnum.BauleistungLuksch:
            return "0% §19 Bauleistung";
        case LedgerImportTaxTypeEnum.InnergemeinschaftlicheLieferungLuksch:
            return "Innergemeinschaftliche Lieferung";
        default:
            throw 'taxType not implemented' + taxType;
    }
};
/**
 * WIRD AUCH IM ACCOUNTING BE GENUTZT
 * @param taxType
 */
export const getLedgerImportTaxTypeTaxValue = (taxType: LedgerImportTaxTypeEnum) => {
    switch (taxType) {
        case LedgerImportTaxTypeEnum.Twenty:
            return 20;
        case LedgerImportTaxTypeEnum.Nineteen:
            return 19;
        case LedgerImportTaxTypeEnum.Sixteen:
            return 16;
        case LedgerImportTaxTypeEnum.Seven:
            return 7;
        case LedgerImportTaxTypeEnum.Five:
            return 5;
        case LedgerImportTaxTypeEnum.ReverseChargeLuksch:
        case LedgerImportTaxTypeEnum.Paragraph_13bLuksch:
        case LedgerImportTaxTypeEnum.Paragraph_19aLuksch:
        case LedgerImportTaxTypeEnum.ReverseCharge:
        case LedgerImportTaxTypeEnum.Photovoltaik:
        case LedgerImportTaxTypeEnum.Kleinunternehmer:
            return 0;
        default:
            throw 'taxType not implemented' + taxType;
    }
}
// use Record for typescript error if "TaxTypes" changes
const customerTaxTypesToLedgerImportTaxTypes: Record<TaxTypes, LedgerImportTaxTypeEnum> = {
    [TaxTypes.Brutto]: LedgerImportTaxTypeEnum.Nineteen,
    [TaxTypes.Netto]: LedgerImportTaxTypeEnum.Nineteen,
    [TaxTypes.EGLeistung]: LedgerImportTaxTypeEnum.Nineteen,
    [TaxTypes.Free]: LedgerImportTaxTypeEnum.Kleinunternehmer,
    [TaxTypes.Steuerschuldumkehr]: LedgerImportTaxTypeEnum.ReverseCharge,
}
export const getLedgerImportTaxTypeByCustomerTaxType = (taxType: TaxTypes) => customerTaxTypesToLedgerImportTaxTypes[taxType];
export const LedgerImportTaxTypeOptions: (partnerId: number) => Array<{name: string, value: LedgerImportTaxTypeEnum}> = (partnerId) => {
    const isLuksch = partnerId === window['env']['luksch_partner_id'];
    const isLukschDe = partnerId === window['env']['luksch_partner_id2'];

    const all = Object.keys(LedgerImportTaxTypeEnum).map(key => ({
        value: LedgerImportTaxTypeEnum[key],
        name: getLedgerImportTaxTypeName(LedgerImportTaxTypeEnum[key], partnerId),
    }));
    return isLuksch || isLukschDe
        ? all.filter((to) => to.value !== LedgerImportTaxTypeEnum.ReverseCharge)
        : all.filter((to) => to.value !== LedgerImportTaxTypeEnum.ReverseChargeLuksch && to.value !== LedgerImportTaxTypeEnum.Paragraph_13bLuksch && to.value !== LedgerImportTaxTypeEnum.Paragraph_19aLuksch)
}

interface groupInterface {
    name?: string;
    uniqId?: number;
    type: 'group' | 'group-end' | 'text' | 'arl';
}


export const DEFAULT_INVOICE_NK: LedgerImportEntity['LVKalkulationNebenkosten'] = [
        { name: '', comment: '', gewerke: [0] },

    ];
export const DEFAULT_INVOICE_NK_GEWERKE: LedgerImportEntity['LVKalkulationNebenkostenGewerke'] = ['Gewerk 1'];

export interface LedgerImportAdditionalData {
    twigTemplateId?: number;
    notes?: string;
    assignedUserId?: number;
    ourSign?: string;
    customerNumber?: string;
    tempBookingPosition?: any;
    LvARLSurchargesByType?: LedgerImportARLSurchargesByType[]; //todo in eigenes feld auslagern
    quantityFormulaVariableScope?: string; //todo in eigenes feld auslagern
    // lvKalkulationNebenkostenGewerke?: string[];
    // lvKalkulationNebenkosten?: {name: string, comment: string, gewerke: number[]}[];
}
// Key und Value muss gleich sein
export enum LedgerImportStatusEnum {
    Neu = 'NEU',
    Versandt = 'VERSANDT',
    Gebucht = 'GEBUCHT',
    Verrechnet = 'VERRECHNET',
    Storniert = 'STORNIERT',
    AngebotAkzeptiert = 'ANGEBOT_AKZEPTIERT',
}
//enum('invoice','offer','order','orderConfirmation','partial_invoice','closing_invoice','offerConfirmation','measurement','deliveryNote','cancellation','credit')
export enum LedgerImportDocumentTypes {
    Invoice = 'invoice',
    Offer = 'offer',
    OfferConfirmation = 'offerConfirmation',
    Order = 'order',
    OrderConfirmation = 'orderConfirmation',
    PartialInvoice = 'partial_invoice',
    ClosingInvoice = 'closing_invoice',
    Measurement = 'measurement',
    DeliveryNote = 'deliveryNote',
    Cancellation = 'cancellation',
    Credit = 'credit',
    ReturnDeliveryNote = 'returnDeliveryNote',
}

/**
 * Prefix für die Nummerngenerierung.
 * Wird im Frontend für die Sortierung benötigt.
 * !!! Steht auch im Accountingbackend, LedgerImportDatabase.cs, MakeConsolidatedInvoiceId, Zeile 80
 */
const docTypeNumberPrefixLength: Record<LedgerImportDocumentTypes, number> = {
    [LedgerImportDocumentTypes.Invoice]: 1, // R
    [LedgerImportDocumentTypes.Offer]: 2, // AN
    [LedgerImportDocumentTypes.OfferConfirmation]: 2, // AB
    [LedgerImportDocumentTypes.Order]: 2, // BE
    [LedgerImportDocumentTypes.OrderConfirmation]: 3, // BEB
    [LedgerImportDocumentTypes.PartialInvoice]: 1, // R
    [LedgerImportDocumentTypes.ClosingInvoice]: 1, // R
    [LedgerImportDocumentTypes.Measurement]: 3, // AUF
    [LedgerImportDocumentTypes.DeliveryNote]: 2, // LS
    [LedgerImportDocumentTypes.Cancellation]: 2, // ST
    [LedgerImportDocumentTypes.Credit]: 2, // GS
    [LedgerImportDocumentTypes.ReturnDeliveryNote]: 2, // LS
}
/**
 * gibt den Index der fortlaufenden Zahl aus der Rechnungsnummer zurück
 * prefix + "YYYYMM-"(7)
 * z.B.: R202201-123
 * @param type
 */
const getDefaultInvoiceNumberCountStartIndex = (type: LedgerImportDocumentTypes) => {
    return docTypeNumberPrefixLength[type] + 7;
}
export enum LedgerImportGaebFileTypes {
    GaebXml = 'GaebXml',
    Gaeb2000 = 'Gaeb2000',
    Gaeb90 = 'Gaeb90',
    UglFT = 'UglFT',
    OenormFT = 'OenormFT',
    Oenorm_B2063 = 'Oenorm_B2063'
}

export enum LedgerImportColumnsNamesInDocumentEnum {
    BaseCost = 'BaseCost',
    BaseCostGross = 'BaseCostGross',
    BaseCostOther = 'BaseCost_other',
    BaseCostSalary = 'BaseCost_salary',
    BookingText = 'BookingText',
    CompleteCost = 'CompleteCost',
    CompleteCostGross = 'CompleteCostGross',
    Information = 'Information',
    Position = 'Position',
    Quantity = 'Quantity',
    QuantityType = 'QuantityType'
}

const LedgerImportColumnsNamesInDocumentEnumGrpc = new Map<string, LedgerImportColumnsNamesInDocumentEnum>([
    ['BaseCost', LedgerImportColumnsNamesInDocumentEnum.BaseCost],
    ['BaseCostGross', LedgerImportColumnsNamesInDocumentEnum.BaseCostGross],
    ['BaseCostOther', LedgerImportColumnsNamesInDocumentEnum.BaseCostOther],
    ['BaseCost_other', LedgerImportColumnsNamesInDocumentEnum.BaseCostOther],
    ['BaseCostSalary', LedgerImportColumnsNamesInDocumentEnum.BaseCostSalary],
    ['BaseCost_salary', LedgerImportColumnsNamesInDocumentEnum.BaseCostSalary],
    ['BookingText', LedgerImportColumnsNamesInDocumentEnum.BookingText],
    ['CompleteCost', LedgerImportColumnsNamesInDocumentEnum.CompleteCost],
    ['CompleteCostGross', LedgerImportColumnsNamesInDocumentEnum.CompleteCostGross],
    ['Information', LedgerImportColumnsNamesInDocumentEnum.Information],
    ['Position', LedgerImportColumnsNamesInDocumentEnum.Position],
    ['Quantity', LedgerImportColumnsNamesInDocumentEnum.Quantity],
    ['QuantityType', LedgerImportColumnsNamesInDocumentEnum.QuantityType],
]);

const BusinessVolumeCostStateEnumGrpc = new Map<string, BusinessVolumeCostStateEnum>([
    ['costs', BusinessVolumeCostStateEnum.Costs],
    ['COSTS', BusinessVolumeCostStateEnum.Costs],
    ['income', BusinessVolumeCostStateEnum.Income],
    ['INCOME', BusinessVolumeCostStateEnum.Income],
    ['notset', BusinessVolumeCostStateEnum.Notset],
    ['NOTSET', BusinessVolumeCostStateEnum.Notset],
]);

export const ledgerImportStatusValues: LedgerImportStatusEnum[] = Object.values(LedgerImportStatusEnum).filter(x => typeof x === "string");
export const ledgerImportDocumentTypesValues: LedgerImportDocumentTypes[] = Object.values(LedgerImportDocumentTypes).filter(x => typeof x === "string");
export const ledgerImportGaebFileTypesValues: LedgerImportGaebFileTypes[] = Object.values(LedgerImportGaebFileTypes).filter(x => typeof x === "string");
export const LedgerImportStatusNames: Map<LedgerImportStatusEnum, string> = new Map<LedgerImportStatusEnum, string>([
    [LedgerImportStatusEnum.Neu, 'Neu'],
    [LedgerImportStatusEnum.Versandt, 'Versandt'],
    [LedgerImportStatusEnum.Gebucht, 'Gebucht'],
    [LedgerImportStatusEnum.Verrechnet, 'Bezahlt'],
    [LedgerImportStatusEnum.Storniert, 'Storniert'],
    [LedgerImportStatusEnum.AngebotAkzeptiert, 'Bestätigt'],
]);
export const LedgerImportDocumentTypeNames: Map<LedgerImportDocumentTypes, string> = new Map<LedgerImportDocumentTypes, string>([
    [LedgerImportDocumentTypes.Invoice, 'Rechnung'],
    [LedgerImportDocumentTypes.Offer, 'Angebot'],
    [LedgerImportDocumentTypes.OfferConfirmation, 'Auftragsbestätigung'],
    [LedgerImportDocumentTypes.Order, 'Bestellung'],
    [LedgerImportDocumentTypes.OrderConfirmation, 'Bestellbestätigung'],
    [LedgerImportDocumentTypes.PartialInvoice, 'Abschlagsrechnung'],
    [LedgerImportDocumentTypes.ClosingInvoice, 'Schlussrechnung'],
    [LedgerImportDocumentTypes.Measurement, 'Aufmaß'],
    [LedgerImportDocumentTypes.DeliveryNote, 'Lieferschein'],
    [LedgerImportDocumentTypes.ReturnDeliveryNote, 'Retourenlieferschein'],
    [LedgerImportDocumentTypes.Cancellation, 'Storno'],
    [LedgerImportDocumentTypes.Credit, 'Gutschrift'],
]);
export const LedgerImportDocumentTypeShortNames: Map<LedgerImportDocumentTypes, string> = new Map<LedgerImportDocumentTypes, string>([
    [LedgerImportDocumentTypes.Invoice, 'Re'],
    [LedgerImportDocumentTypes.Offer, 'An'],
    [LedgerImportDocumentTypes.OfferConfirmation, 'AB'],
    [LedgerImportDocumentTypes.Order, 'BE'],
    [LedgerImportDocumentTypes.OrderConfirmation, 'BEB'],
    [LedgerImportDocumentTypes.PartialInvoice, 'Re'],
    [LedgerImportDocumentTypes.ClosingInvoice, 'Re'],
    [LedgerImportDocumentTypes.Measurement, 'AUF'],
    [LedgerImportDocumentTypes.DeliveryNote, 'LS'],
    [LedgerImportDocumentTypes.ReturnDeliveryNote, 'RLS'],
    [LedgerImportDocumentTypes.Cancellation, 'ST'],
    [LedgerImportDocumentTypes.Credit, 'GS'],
]);
export const LedgerImportDocumentTypeNumberLabel: Map<LedgerImportDocumentTypes, string> = new Map<LedgerImportDocumentTypes, string>([
    [LedgerImportDocumentTypes.Invoice, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.Invoice) + '-Nr.'],
    [LedgerImportDocumentTypes.Offer, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.Offer) + '-Nr.'],
    [LedgerImportDocumentTypes.OfferConfirmation, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.OfferConfirmation) + '-Nr.'],
    [LedgerImportDocumentTypes.Order, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.Order) + '-Nr.'],
    [LedgerImportDocumentTypes.OrderConfirmation, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.OrderConfirmation) + '-Nr.'],
    [LedgerImportDocumentTypes.PartialInvoice, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.PartialInvoice) + '-Nr.'],
    [LedgerImportDocumentTypes.ClosingInvoice, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.ClosingInvoice) + '-Nr.'],
    [LedgerImportDocumentTypes.Measurement, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.Measurement) + '-Nr.'],
    [LedgerImportDocumentTypes.DeliveryNote, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.DeliveryNote) + '-Nr.'],
    [LedgerImportDocumentTypes.ReturnDeliveryNote, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.ReturnDeliveryNote) + '-Nr.'],
    [LedgerImportDocumentTypes.Cancellation, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.Cancellation) + '-Nr.'],
    [LedgerImportDocumentTypes.Credit, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.Credit) + '-Nr.'],
]);
export const LedgerImportDocumentTypeDateLabel: Map<LedgerImportDocumentTypes, string> = new Map<LedgerImportDocumentTypes, string>([
    [LedgerImportDocumentTypes.Invoice, 'Rechnungsdatum'],
    [LedgerImportDocumentTypes.Offer, 'Angebotsdatum'],
    [LedgerImportDocumentTypes.OfferConfirmation, 'Auftragsbestätigungsdatum'],
    [LedgerImportDocumentTypes.Order, 'Bestellungsdatum'],
    [LedgerImportDocumentTypes.OrderConfirmation, 'Bestellbestätigungsdatum'],
    [LedgerImportDocumentTypes.PartialInvoice, 'Rechnungsdatum'],
    [LedgerImportDocumentTypes.ClosingInvoice, 'Rechnungsdatum'],
    [LedgerImportDocumentTypes.Measurement, 'Aufmaßdatum'],
    [LedgerImportDocumentTypes.DeliveryNote, 'Lieferscheindatum'],
    [LedgerImportDocumentTypes.ReturnDeliveryNote, 'Lieferscheindatum'],
    [LedgerImportDocumentTypes.Cancellation, 'Stornodatum'],
    [LedgerImportDocumentTypes.Credit, 'Gutschriftdatum'],
]);
export const LedgerImportDocumentTypeShortDateLabel: Map<LedgerImportDocumentTypes, string> = new Map<LedgerImportDocumentTypes, string>([
    [LedgerImportDocumentTypes.Invoice, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.Invoice) + '-Datum.'],
    [LedgerImportDocumentTypes.Offer, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.Offer) + '-Datum.'],
    [LedgerImportDocumentTypes.OfferConfirmation, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.OfferConfirmation) + '-Datum.'],
    [LedgerImportDocumentTypes.Order, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.Order) + '-Datum.'],
    [LedgerImportDocumentTypes.OrderConfirmation, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.OrderConfirmation) + '-Datum.'],
    [LedgerImportDocumentTypes.PartialInvoice, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.PartialInvoice) + '-Datum.'],
    [LedgerImportDocumentTypes.ClosingInvoice, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.ClosingInvoice) + '-Datum.'],
    [LedgerImportDocumentTypes.Measurement, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.Measurement) + '-Datum.'],
    [LedgerImportDocumentTypes.DeliveryNote, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.DeliveryNote) + '-Datum.'],
    [LedgerImportDocumentTypes.ReturnDeliveryNote, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.ReturnDeliveryNote) + '-Datum.'],
    [LedgerImportDocumentTypes.Cancellation, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.Cancellation) + '-Datum.'],
    [LedgerImportDocumentTypes.Credit, LedgerImportDocumentTypeShortNames.get(LedgerImportDocumentTypes.Credit) + '-Datum.'],
]);
export const LedgerImportDocumentTypeCanHaveBusinessVolume = (type: LedgerImportDocumentTypes) => {
    return [
        LedgerImportDocumentTypes.Invoice,
        LedgerImportDocumentTypes.PartialInvoice,
        LedgerImportDocumentTypes.ClosingInvoice,
        LedgerImportDocumentTypes.DeliveryNote,
        LedgerImportDocumentTypes.Cancellation,
        LedgerImportDocumentTypes.Credit,
        LedgerImportDocumentTypes.ReturnDeliveryNote,
    ].includes(type)
}
export const getDueDateFromLedgerImportDocumentType = (type: LedgerImportDocumentTypes) => type === LedgerImportDocumentTypes.Offer ? 'Gültig bis' : 'Fälligkeitsdatum'
const getInvoiceNumberCountStartIndex = (additionaldata: PartnerOfficeAdditionalData, documentType: LedgerImportDocumentTypes) => {
    let startCounter: number = null;

    if (additionaldata) {
        switch (documentType) {
            case LedgerImportDocumentTypes.Invoice:
            case LedgerImportDocumentTypes.PartialInvoice:
            case LedgerImportDocumentTypes.ClosingInvoice:
                startCounter = additionaldata.RechnungsnNummer?.startCounter;
                break;
            case LedgerImportDocumentTypes.Offer:
                startCounter = additionaldata.AngebotsNummer?.startCounter;
                break;
            case LedgerImportDocumentTypes.OfferConfirmation:
            case LedgerImportDocumentTypes.Order:
            case LedgerImportDocumentTypes.OrderConfirmation:
            case LedgerImportDocumentTypes.Measurement:
            case LedgerImportDocumentTypes.DeliveryNote:
            case LedgerImportDocumentTypes.Cancellation:
            case LedgerImportDocumentTypes.Credit:
                // es gibt keine "Custom Nummern" (mehr) für diese Dokumentenarten
                break;
        }
    }
    if (!isNotNullOrUndefined(startCounter)) {
        startCounter = getDefaultInvoiceNumberCountStartIndex(documentType);
    }
    return startCounter;
}
export class LedgerImportEntity {
    public static sortCompare(
        li1: Pick<LedgerImportEntity, 'ConsolidatedInvoiceId' | 'DocumentType'>,
        li2: Pick<LedgerImportEntity, 'ConsolidatedInvoiceId' | 'DocumentType'>,
        additionalData1: PartnerOfficeAdditionalData,
        additionalData2: PartnerOfficeAdditionalData,
    ) {
        if ((li1.ConsolidatedInvoiceId || '') === (li2.ConsolidatedInvoiceId || '')) {
            return 0;
        }
        if (!li1.ConsolidatedInvoiceId) {
            return -1;
        } else if (!li2.ConsolidatedInvoiceId) {
            return 1;
        }
        const i1 = getInvoiceNumberCountStartIndex(additionalData1, li1.DocumentType);
        const i2 = getInvoiceNumberCountStartIndex(additionalData2, li2.DocumentType);
        const c = li1.ConsolidatedInvoiceId.substring(0, i1).localeCompare(li2.ConsolidatedInvoiceId.substring(0, i2));
        if (c === 0) {
            const ex1 = +li1.ConsolidatedInvoiceId.substring(i1);
            const ex2 = +li2.ConsolidatedInvoiceId.substring(i2);
            if (isNaN(ex1) && isNaN(ex2)) {
                return 0;
            } else if (isNaN(ex1)) {
                return -1;
            } else if (isNaN(ex2)) {
                return 1;
            }
            return ex1 - ex2;
        } else {
            return c;
        }
    }

    public static GetRegex(invoiceNumber: string, additionaldata: PartnerOfficeAdditionalData, documentType: LedgerImportDocumentTypes) {
        //when there's no invoicenumber, just return 0
        if (!invoiceNumber) {
            return 0;
        }
        const extractedNR = invoiceNumber.substring(getInvoiceNumberCountStartIndex(additionaldata, documentType));
        console.log(invoiceNumber, extractedNR);
        const asNr = +extractedNR;
        return isNaN(asNr) ? 0 : asNr;
    }
    constructor(
        public Id: number = null,
        // public Xmlns: string = null, // - string (XSD - Version - default: "http://xml.datev.de/bedi/tps/ledger/v050"
        // public XmlnsXsi: string = null, // - string (default: "http://www.w3.org/2001/XMLSchema-instance"
        // public XsiSchemaLocation: string = null, // - string (default: "http://xml.datev.de/bedi/tps/ledger/v050 Belegverwaltung_online_ledger_import_v050.xsd"
        // public GeneratorInfo: string = null, // - string (default: dave - company cloud GmbH)
        // public Version: string = null, // - string (default: 5.0)
        // public XmlData: string = null, // - string (default: "Kopie nur zur Verbuchung berechtigt nicht zum Vorsteuerabzug"
        // public GeneratingSystem: string = null, // - string (default: dave)
        public ConsolidatedAmount: number = null, // - float (Gesamtbetrag aller accountsreceivableLedger)
        public ConsolidatedDate: Date = null, // - date (rechungsdatum -> Datev Format: yyyy-mm-dd)
        public ConsolidatedInvoiceId: string = null, // - string (Rechnungsnr)
        public ConsolidatedCurrencyCode: string = null, // - char 3 (default: EUR)
        public ConsolidatedDeliveryDate: Date = null, // - date nullable (Leistungsdatum Datev Format: yyyy-mm-dd)
        public ConsolidatedOrderId: string = null, // - date nullable (TransaktionsId für Zahlungsreferenz)

        public PartnerId: number = null,
        public UserId: number = null,
        public CustomerId: number = null,
        public CreatedAt: Date = null,

        public AccountNumber: string = null,
        public Bankname: string = null,
        public Bic: string = null,
        public Blz: string = null,
        public Iban: string = null,
        public TextBottom: string = null,
        public TextTop: string = null,
        public UstId: string = null,

        public AccountsReceivableLedgerIds: number[] = null,
        public CommissionId: number = null,
        public CustomerCity: string = null,
        public CustomerCountry: string = null,
        public CustomerEmail: string = null,
        public CustomerName: string = null,
        public CustomerPostalCode: string = null,
        public CustomerStreet: string = null,
        public DocumentId: number = null,
        public PartnerCity: string = null,
        public PartnerCountry: string = null,
        public PartnerEmail: string = null,
        public PartnerPhoneNumber: string = null,
        public PartnerPostalCode: string = null,
        public PartnerStreet: string = null,
        // public SFDT: string = null, auskommentiert damit wir das nicht immer mit ins FE laden
        public Status: LedgerImportStatusEnum = null,
        public UpdatedAt: Date = null,
        public UserEmail: string = null,
        public UserName: string = null,
        public PartnerName: string = null,
        public DocumentType: LedgerImportDocumentTypes = null,
        public RootId: number = null,
        public GuaranteedDiscountPercentage: number = null,
        public IsTemplate: boolean = null,
        public DiscountPaymentDate: Date = null,
        public DiscountPaymentDate2: Date = null,
        public DiscountPercentage: number = null,
        public DiscountPercentage2: number = null,
        public DueDate: Date = null,
        public PartnerOfficeId: number = null,
        public DocumentIdXRechnung: number = null,
        public AdditionalData: LedgerImportAdditionalData = null,
        public AutomaticInvoiceId: boolean = null,
        public CeoName: string = null,
        public RegistryCourt: string = null,
        public CommercialRegister: string = null,
        /**
         * This is a special property that is true if someone has modified an arl from the ledger import without updating the sfdt.
         */
        public IsDirty: boolean = null,
        public CommissionNumber: string = null,
        //  public EventId: number = null,
        public HideNetto: boolean = null,
        // public AccountsReceivableLedgerIdsFromLedgerImports: number[] = null,
        public AlreadyPayed: number = null, // Bereits gezahlter amount, also das gleiche wie im Businessvolume, wird aber nicht automatisch aktualisiert
        public PartialInvoiceCounter: number = null,
        public ConsolidatedNettoAmount: number = null,
        public TaxType: LedgerImportTaxTypeEnum = null,
        /**
         * Spalte anzeigen
         */
        public ShowAmount: boolean = null,
        /**
         * Spalte anzeigen
         */
        public ShowBaseCost: boolean = null,
        /**
         * Spalte anzeigen
         */
        public ShowAmountGross: boolean = null,
        /**
         * Spalte anzeigen
         */
        public ShowBaseCostGross: boolean = null,
        /**
         * Spalte anzeigen
         */
        public ShowBookingText: boolean = null,
        /**
         * Spalte anzeigen
         */
        public ShowInformation: boolean = null,
        /**
         * Spalte anzeigen
         */
        public ShowPosition: boolean = null,
        /**
         * Spalte anzeigen
         */
        public ShowQuantity: boolean = null,
        /**
         * Spalte anzeigen
         */
        public ShowQuantityType: boolean = null,
        public ShowSignature: boolean = null,
        /**
         * "Enthaltene MWST anzeigen", nur relevant wenn HideNetto === true
         */
        public ShowTaxSum: boolean = null,
        public Title: string = null,
        public UserPhoneNumber: string = null,
        public DeliveryTime: string = null,
        public ConsolidatedDeliveryDate2: Date | null = null, // Leistungsdatum

        public AllowanceCharges: LedgerImportAllowanceCharge[] = null,
        public ARLCalculationPreChargeByType: LedgerImportARLCalculationPreChargeByType[] = null,
        public ARLCalculationGlobalPreCharge: number = null,
        public SkontoIsAllowance: boolean = null,
        /**
         * für Luksch invoice-calculation
         */
        public NebenKostenPercent: number = null,
        public EmployeeArlQuantityTypeId: number = null,
        public GaebfromVersionId: number = null,
        public GaebExportedDocumentIds: GabeIds = null,
        public BreakPageMode: LedgerImportBreakPageModeEnum | null = null,
        /**
         * Spalte anzeigen
         */
        public ShowSalaryBaseCost: boolean = null,
        /**
         * Spalte anzeigen
         */
        public ShowOtherBaseCost: boolean = null,
        public DeliveryStreet: string = null,
        public DeliveryName: string = null,
        public DeliveryPostalCode: string = null,
        public DeliveryCity: string = null,
        public ServicePeriod: string = null,
        public TextBottomFirst: string = null,
        public ArlTableStartOnNewPage: boolean = null,
        public ShowTextBottomFirst: boolean = null,
        public UseListPriceForNewMaterials: boolean = null,

        public RetentionPercentage: number = null, // float
        public WarrantyRetentionPercentage: number = null, // float

        public ReviewPeriodText: string | null = null,
        public SkontoPeriodText: string | null = null,

        public ClosingInvoiceDiscountPeriod: number | null = null, // int
        public ClosingInvoiceDuePeriod: number | null = null, // int
        public ClosingInvoiceReviewPeriod: number | null = null, // int
        public PartialInvoiceDiscountPeriod: number | null = null, // int
        public PartialInvoiceDuePeriod: number | null = null, // int
        public PartialInvoiceReviewPeriod: number | null = null, // int
        public UseQuantityHistory: boolean | null = null,
        public InvoiceItems: LedgerImportInvoiceItem[] | null = null,
        public PaymentItems: LedgerImportPaymentItem[] | null = null,

        /**
         * für Luksch invoice-calculation
         */
        public PartieStd: number | null = null,
        public EventIds: number[] = null,
        /**
         * Für LV Kalkulation
         */
        public LvARLSurchargesByType: LedgerImportARLSurchargesByType[] = null,

        public IsLVCalculated: boolean = null,
        public LVKalkulationNebenkosten: { name?: string; comment?: string; gewerke?: number[] }[] = null,
        public LVKalkulationNebenkostenGewerke: string[] = null,
        public ARLReadOnlyModeSetByUser: boolean = null,
        public GabeImportedType: LedgerImportGaebFileTypes = null,
        public ShowLongInformation: boolean = null,
        public HideLetterHead: boolean = null,
        public DocumentStatus: DocumentStatusEnum = null,
        public ColumnsNamesInDocument: LedgerImportColumnsNamesInDocumentEnum[] = null,
        public DeletedAt: Date = null,
        public UseDeliveryAddressFromCommission: boolean = null,
        /**
         * Spalte anzeigen
         */
        public ShowSalaryBaseCost_cost: boolean = null,
        /**
         * Spalte anzeigen
         */
        public ShowOtherBaseCost_cost: boolean = null,
        /**
         * Spalte anzeigen
         */
        public ShowBaseCost_cost: boolean = null,
        /**
         * Spalte anzeigen
         */
        public ShowBaseCostGross_cost: boolean = null,
        /**
         * Spalte anzeigen
         */
        public TaxTypeId: number = null,

        public ShowQRCode: boolean = null,
        public PartnerAccountHolder: string = null,
        public ItemNumbersLocked: boolean = null,
        public InvoiceItemTableStartOnNewPage: boolean = null,
        public HideSumTable: boolean = null,
        public HidePositionsWithoutQuantity: boolean = null,
        public CustomerUstId: string = null,
    ) {}

    GetBackgroundColorClass() {
        switch (this.Status) {
            case LedgerImportStatusEnum.Verrechnet:
                return 'app-color-invoice-verrechnet';
            case LedgerImportStatusEnum.Gebucht:
                if (this.DueDate < new Date()) {
                    return 'app-color-late';
                } else {
                    return 'app-color-invoice-booked';
                }
            case LedgerImportStatusEnum.Storniert:
                return 'app-color-invoice-storniert';
            case LedgerImportStatusEnum.AngebotAkzeptiert:
                return 'app-color-invoice-approved';
        }
    }
    public static IsLedgerImportTypeInvoice(type: LedgerImportDocumentTypes) {
        return [LedgerImportDocumentTypes.Invoice, LedgerImportDocumentTypes.PartialInvoice, LedgerImportDocumentTypes.ClosingInvoice].includes(type);
    }
    public get IsInvoice(): boolean {
        return LedgerImportEntity.IsLedgerImportTypeInvoice(this.DocumentType);
    }
    // public static CanBeClosingInvoiceRootDocumentTypes = [
    //     LedgerImportDocumentTypes.Offer,
    //     LedgerImportDocumentTypes.OfferConfirmation,
    //     LedgerImportDocumentTypes.Measurement,
    //     LedgerImportDocumentTypes.Invoice,
    //     LedgerImportDocumentTypes.PartialInvoice,
    // ];
    // get canBeClosingInvoiceRoot() {
    //     return LedgerImportEntity.CanBeClosingInvoiceRootDocumentTypes.includes(this.DocumentType);
    // }
    // public get IsInvoiceOrOffer(): 'invoice' | 'offer' {
    //     switch (this.DocumentType) {
    //         case LedgerImportDocumentTypes.Invoice:
    //             return 'invoice';
    //         case LedgerImportDocumentTypes.PartialInvoice:
    //             return 'invoice';
    //         case LedgerImportDocumentTypes.ClosingInvoice:
    //             return 'invoice';
    //         case LedgerImportDocumentTypes.Offer:
    //             return 'offer';
    //         default:
    //             return undefined;
    //     }
    // }
    public static readonly PaymentItemGqlFields: Array<keyof LedgerImportType['paymentItems'][0]> = ['bVType', 'businessVolumeId', 'businessVolumeNo', 'payedAmountBrutto', 'payedAmountNetto', 'paymentDate'];
    public static readonly LVKalkulationNebenkostenGqlFields: Array<keyof LedgerImportType['lVKalkulationNebenkosten'][0]> = ['comment', 'gewerke', 'name'];

    public static readonly GqlFields: Array<keyof LedgerImportType> = [
        'accountNumber',
        'accountsReceivableLedgerIds',
        'bankname',
        'bic',
        'blz',
        'commissionId',
        'consolidatedAmount',
        'consolidatedCurrencyCode',
        'consolidatedDate',
        'consolidatedDeliveryDate',
        'consolidatedInvoiceId',
        'consolidatedOrderId',
        'createdAt',
        'customerCity',
        'customerCountry',
        'customerEmail',
        'customerId',
        'customerName',
        'customerPostalCode',
        'customerStreet',
        'discountPaymentDate',
        'discountPaymentDate2',
        'discountPercentage',
        'discountPercentage2',
        'documentId',
        'documentType',
        'guaranteedDiscountPercentage',
        'iban',
        'id',
        'isTemplate',
        'partnerCity',
        'partnerCountry',
        'partnerEmail',
        'partnerId',
        'partnerName',
        'partnerPhoneNumber',
        'partnerPostalCode',
        'partnerStreet',
        'rootId',
        'status',
        'textBottom',
        'textTop',
        'updatedAt',
        'userEmail',
        'userId',
        'userName',
        'ustId',
        'dueDate',
        'partnerOfficeId',
        'documentIdXRechnung',
        'additionalData',
        'automaticInvoiceId',
        'cEOName',
        'registryCourt',
        'commercialCourt',
        'isDirty',
        'commissionNumber',
        //'eventId',
        'hideNetto',
        // 'accountsReceivableLedgerIdsFromLedgerImports',
        'partialInvoiceCounter',
        'consolidatedNettoAmount',
        'taxTypeId',
        'showAmount',
        'showBaseCost',
        'showAmountGross',
        'showBaseCostGross',
        'showBookingText',
        'showInformation',
        'showPosition',
        'showQuantity',
        'showQuantityType',
        'showSignature',
        'showTaxSum',
        'title',
        'userPhoneNumber',
        'deliveryTime',
        'consolidatedDeliveryDate2',
        'allowanceCharges',
        'aRLCalculationPreChargeByType',
        'aRLCalculationGlobalPreCharge',
        'skontoIsAllowance',
        'nebenKostenPercent',
        'gaebfromVersionId',
        'gaebExportedDocumentIds',
        'employeeArlQuantityTypeId',
        'gaebfromVersionId',
        'gaebExportedDocumentIds',
        'breakPageMode',
        'showSalaryBaseCost',
        'showOtherBaseCost',
        'deliveryStreet',
        'deliveryName',
        'deliveryPostalCode',
        'deliveryCity',
        'servicePeriod',
        'textBottomFirst',
        'arlTableStartOnNewPage',
        'showTextBottomFirst',
        'useListPriceForNewMaterials',
        'retentionPercentage',
        'warrantyRetentionPercentage',
        'reviewPeriodText',
        'skontoPeriodText',
        'closingInvoiceDiscountPeriod',
        'closingInvoiceDuePeriod',
        'closingInvoiceReviewPeriod',
        'partialInvoiceDiscountPeriod',
        'partialInvoiceDuePeriod',
        'partialInvoiceReviewPeriod',
        // @ts-ignore
        'invoiceItems { amountBrutto, amountNetto, invoiceDate, invoiceNo, ledgerImportId, name }',
        // @ts-ignore
        `paymentItems { ${LedgerImportEntity.PaymentItemGqlFields.join(',')} }`,
        'useQuantityHistory',
        'partiestd',
        'eventIds',
        'isLVCalculated',
        // @ts-ignore
        `lVKalkulationNebenkosten {${LedgerImportEntity.LVKalkulationNebenkostenGqlFields.join(',')}}`,
        'lVKalkulationNebenkostenGewerke',
        'aRLReadOnlyModeSetByUser',
        'gabeImportedType',
        'showLongInformation',
        'hideLetterHead',
        'documentStatus',
        'columnsNamesInDocument',
        'deletedAt',
        'useDeliveryAddressFromCommission',
        'deletedAt',
        'showSalaryBaseCost_cost',
        'showOtherBaseCost_cost',
        'showBaseCost_cost',
        'showBaseCostGross_cost',
        'showQRCode',
        'partnerAccountHolder',
        'itemNumbersLocked',
        'invoiceItemTableStartOnNewPage',
        'hideSumTable',
        'hidePositionsWithoutQuantity',
        'customerUstId',
    ]; // sFDT
    public Clone(override: Partial<LedgerImportEntity> = {}): LedgerImportEntity {
        const attr = { ...this, ...override };
        return Object.assign(new LedgerImportEntity(), attr);
    }
    public AvailableStates(isAdmin: boolean): { optionLabel: string; optionValue: LedgerImportStatusEnum }[] {
        const statusListIfCancled = [
            {
                optionLabel: LedgerImportStatusNames.get(LedgerImportStatusEnum.Storniert),
                optionValue: LedgerImportStatusEnum.Storniert,
            },
        ];
        const statusListIfOfferAccepted = [
            {
                optionLabel: LedgerImportStatusNames.get(LedgerImportStatusEnum.AngebotAkzeptiert),
                optionValue: LedgerImportStatusEnum.AngebotAkzeptiert,
            },
        ];
        const statusListIfVerrechnet = [
            {
                optionLabel: LedgerImportStatusNames.get(LedgerImportStatusEnum.Verrechnet),
                optionValue: LedgerImportStatusEnum.Verrechnet,
            },
            ...statusListIfCancled,
        ];
        const statusListIfBookedOrDone = [
            {
                optionLabel: LedgerImportStatusNames.get(LedgerImportStatusEnum.Gebucht),
                optionValue: LedgerImportStatusEnum.Gebucht,
            },
            ...statusListIfVerrechnet,
        ];
        const statusListIfSend = [
            {
                optionLabel: LedgerImportStatusNames.get(LedgerImportStatusEnum.Versandt),
                optionValue: LedgerImportStatusEnum.Versandt,
            },
            ...([LedgerImportDocumentTypes.Offer, LedgerImportDocumentTypes.OfferConfirmation].includes(this.DocumentType) ? statusListIfOfferAccepted : statusListIfBookedOrDone),
        ];
        const statusListIfNew = [
            {
                optionLabel: LedgerImportStatusNames.get(LedgerImportStatusEnum.Neu),
                optionValue: LedgerImportStatusEnum.Neu,
            },
            ...statusListIfSend,
        ];
        let select = [];
        if (!isAdmin) {
            switch (this.Status) {
                case LedgerImportStatusEnum.Storniert:
                    select = statusListIfCancled;
                    break;
                case LedgerImportStatusEnum.Neu:
                    select = statusListIfNew;
                    break;
                case LedgerImportStatusEnum.Gebucht:
                    select = statusListIfBookedOrDone;
                    break;
                case LedgerImportStatusEnum.AngebotAkzeptiert:
                    select = statusListIfOfferAccepted;
                    break;
                case LedgerImportStatusEnum.Verrechnet:
                    select = statusListIfVerrechnet;
                    break;
                default:
                    select = statusListIfSend;
            }
        } else {
            select = statusListIfNew;
        }
        return select;
    }
    get DocumentCanBeDownloaded() {
        return this.DocumentStatus === DocumentStatusEnum.Finished;
    }
}
export function determineIfIsArlEntityOrGroupInterface(toBeDetermined: AccountsReceivableLedgerEntity | groupInterface): toBeDetermined is AccountsReceivableLedgerEntity {
    return toBeDetermined instanceof AccountsReceivableLedgerEntity;
    // return !!(toBeDetermined as AccountsReceivableLedgerEntity).Id;
}

export const fromFloat32 = (v?: number | null): number | null | undefined => {
    if (v == null || !isFinite(v)) return v;
    for (let p = 1; p <= 9; p++) {
        const candidate = Number(v.toPrecision(p));
        if (Math.fround(candidate) === v) return candidate;
    }
    return v;
};

export function LedgerImportEntityFromBackendGrpc(res: LedgerImport): LedgerImportEntity {
    if (res.AllowanceCharges && !isArray(res.AllowanceCharges)) {
        console.error('broken LedgerImport allowanceCharges', res);
        throw 'broken LedgerImport allowanceCharges LedgerImport.Id: ' + res.Id;
    }
    if (res.ARLCalculationPreChargeByType && !isArray(res.ARLCalculationPreChargeByType)) {
        console.error('broken LedgerImport aRLCalculationPreChargeByType', res);
        throw 'broken LedgerImport aRLCalculationPreChargeByType LedgerImport.Id: ' + res.Id;
    }

    return new LedgerImportEntity(
        +res.Id,
        res.ConsolidatedAmount && (+res.ConsolidatedAmount / 100),
        res.ConsolidatedDate ? GetTimeFromTimestamp(+res.ConsolidatedDate) : null,
        res.ConsolidatedInvoiceId,
        res.ConsolidatedCurrencyCode,
        res.ConsolidatedDeliveryDate ? GetTimeFromTimestamp(+res.ConsolidatedDeliveryDate) : null,
        res.ConsolidatedOrderId,
        +res.PartnerId,
        +res.UserId,
        +res.CustomerId,
        res.CreatedAt ? GetTimeFromTimestamp(+res.CreatedAt) : null,
        res.AccountNumber,
        res.Bankname,
        res.Bic,
        res.Blz,
        res.Iban,
        res.TextBottom,
        res.TextTop,
        res.UstId,
        res.AccountsReceivableLedgerIds.map(id => +id),
        +res.CommissionId,
        res.CustomerCity,
        res.CustomerCountry,
        res.CustomerEmail,
        res.CustomerName,
        res.CustomerPostalCode,
        res.CustomerStreet,
        +res.DocumentId,
        res.PartnerCity,
        res.PartnerCountry,
        res.PartnerEmail,
        res.PartnerPhoneNumber,
        res.PartnerPostalCode,
        res.PartnerStreet,
        // res.SFDT,
        LedgerImportStatusEnum[res.Status],
        res.UpdatedAt ? GetTimeFromTimestamp(+res.UpdatedAt) : null,
        res.UserEmail,
        res.UserName,
        res.PartnerName,
        ledgerImportDocumentTypesValues.includes(res.DocumentType as any) ? (res.DocumentType as LedgerImportDocumentTypes) : null,
        +res.RootId,
        fromFloat32(res.GuaranteedDiscountPercentage),
        res.IsTemplate,
        res.DiscountPaymentDate ? GetTimeFromTimestamp(+res.DiscountPaymentDate) : null,
        res.DiscountPaymentDate2 ? GetTimeFromTimestamp(+res.DiscountPaymentDate2) : null,
        fromFloat32(res.DiscountPercentage),
        fromFloat32(res.DiscountPercentage2),
        res.DueDate ? GetTimeFromTimestamp(+res.DueDate) : null,
        +res.PartnerOfficeId,
        +res.DocumentIdXRechnung,
        res.AdditionalData as any,
        res.AutomaticInvoiceId,
        res.CEOName,
        res.RegistryCourt,
        res.CommercialCourt,
        res.IsDirty,
        res.CommissionNumber,
        res.HideNetto,
        null,
        +res.PartialInvoiceCounter,
        +res.ConsolidatedNettoAmount,
        null,
        res.ShowAmount,
        res.ShowBaseCost,
        res.ShowAmountGross,
        res.ShowBaseCostGross,
        res.ShowBookingText,
        res.ShowInformation,
        res.ShowPosition,
        res.ShowQuantity,
        res.ShowQuantityType,
        res.ShowSignature,
        res.ShowTaxSum,
        res.Title,
        res.UserPhoneNumber,
        res.DeliveryTime,
        res.ConsolidatedDeliveryDate2 ? GetTimeFromTimestamp(+res.ConsolidatedDeliveryDate2) : null,
        res.AllowanceCharges as any || [],
        res.ARLCalculationPreChargeByType as any || [],
        fromFloat32(res.ARLCalculationGlobalPreCharge),
        res.SkontoIsAllowance,
        fromFloat32(res.NebenKostenPercent),
        +res.EmployeeArlQuantityTypeId,
        +res.GaebfromVersionId,
        res.GaebExportedDocumentIds as any,
        LedgerImportBreakPageModeEnum[res.BreakPageMode],
        res.ShowSalaryBaseCost,
        res.ShowOtherBaseCost,
        res.DeliveryStreet,
        res.DeliveryName,
        res.DeliveryPostalCode,
        res.DeliveryCity,
        res.ServicePeriod,
        res.TextBottomFirst,
        res.ArlTableStartOnNewPage,
        res.ShowTextBottomFirst,
        res.UseListPriceForNewMaterials,

        fromFloat32(res.RetentionPercentage),
        fromFloat32(res.WarrantyRetentionPercentage),
        res.ReviewPeriodText,
        res.SkontoPeriodText,

        res.ClosingInvoiceDiscountPeriod,
        res.ClosingInvoiceDuePeriod,
        res.ClosingInvoiceReviewPeriod,
        res.PartialInvoiceDiscountPeriod,
        res.PartialInvoiceDuePeriod,
        res.PartialInvoiceReviewPeriod,

        res.UseQuantityHistory,
        res.InvoiceItems ? res.InvoiceItems.map(LedgerImportInvoiceItemFromStringGrpc) : [],
        res.PaymentItems ? res.PaymentItems.map(LedgerImportPaymentItemFromStringGrpc) : [],
        fromFloat32(res.Partiestd),
        res.EventIds.map(id => +id),
        (res.AdditionalData as unknown as LedgerImportAdditionalData)?.LvARLSurchargesByType, //todo in eigenes feld auslagern
        res.IsLVCalculated,
        res.LVKalkulationNebenkosten.map(i => ({
            name: i.Name,
            comment: i.Comment,
            gewerke: i.Gewerke,
        })),
        res.LVKalkulationNebenkostenGewerke,
        res.ARLReadOnlyModeSetByUser,
        ledgerImportGaebFileTypesValues.includes(res.GabeImportedType as any) ? (res.GabeImportedType as LedgerImportGaebFileTypes) : null,
        res.ShowLongInformation,
        res.HideLetterHead,
        DocumentStatusEnum[res.DocumentStatus],
        res.ColumnsNamesInDocument ? res.ColumnsNamesInDocument.map(i => LedgerImportColumnsNamesInDocumentEnumGrpc.get(i) ?? LedgerImportColumnsNamesInDocumentEnum[i]) : [],
        res.DeletedAt && BackendDate(res.DeletedAt),
        res.UseDeliveryAddressFromCommission,
        res.ShowSalaryBaseCostCost,
        res.ShowOtherBaseCostCost,
        res.ShowBaseCostCost,
        res.ShowBaseCostGrossCost,
        +res.TaxTypeId,
        res.ShowQRCode,
        res.PartnerAccountHolder,
        res.ItemNumbersLocked,
        res.InvoiceItemTableStartOnNewPage,
        res.HideSumTable,
        res.HidePositionsWithoutQuantity,
        res.CustomerUstId,
    );
}
export function LedgerImportEntityFromBackend(res: LedgerImportType): LedgerImportEntity {
    if (res.allowanceCharges && !isArray(res.allowanceCharges)) {
        console.error('broken LedgerImport allowanceCharges', res);
        throw 'broken LedgerImport allowanceCharges LedgerImport.Id: ' + res.id;
    }
    if (res.aRLCalculationPreChargeByType && !isArray(res.aRLCalculationPreChargeByType)) {
        console.error('broken LedgerImport aRLCalculationPreChargeByType', res);
        throw 'broken LedgerImport aRLCalculationPreChargeByType LedgerImport.Id: ' + res.id;
    }
    return new LedgerImportEntity(
        res.id,
        res.consolidatedAmount && res.consolidatedAmount / 100,
        res.consolidatedDate ? BackendDate(res.consolidatedDate) : null,
        res.consolidatedInvoiceId,
        res.consolidatedCurrencyCode,
        res.consolidatedDeliveryDate ? BackendDate(res.consolidatedDeliveryDate) : null,
        res.consolidatedOrderId,
        res.partnerId,
        res.userId,
        res.customerId,
        res.createdAt ? BackendDate(res.createdAt) : null,
        res.accountNumber,
        res.bankname,
        res.bic,
        res.blz,
        res.iban,
        res.textBottom,
        res.textTop,
        res.ustId,
        res.accountsReceivableLedgerIds,
        res.commissionId,
        res.customerCity,
        res.customerCountry,
        res.customerEmail,
        res.customerName,
        res.customerPostalCode,
        res.customerStreet,
        res.documentId,
        res.partnerCity,
        res.partnerCountry,
        res.partnerEmail,
        res.partnerPhoneNumber,
        res.partnerPostalCode,
        res.partnerStreet,
        // res.sFDT,
        res.status,
        res.updatedAt ? BackendDate(res.updatedAt) : null,
        res.userEmail,
        res.userName,
        res.partnerName,
        ledgerImportDocumentTypesValues.includes(res.documentType as any) ? (res.documentType as LedgerImportDocumentTypes) : null,
        res.rootId,
        res.guaranteedDiscountPercentage,
        res.isTemplate,
        res.discountPaymentDate ? BackendDate(res.discountPaymentDate) : null,
        res.discountPaymentDate2 ? BackendDate(res.discountPaymentDate2) : null,
        res.discountPercentage,
        res.discountPercentage2,
        res.dueDate ? BackendDate(res.dueDate) : null,
        res.partnerOfficeId,
        res.documentIdXRechnung,
        res.additionalData as any,
        res.automaticInvoiceId,
        res.cEOName,
        res.registryCourt,
        res.commercialCourt,
        res.isDirty,
        res.commissionNumber,
        //res.eventId,
        res.hideNetto,
        // res.accountsReceivableLedgerIdsFromLedgerImports,
        null,
        res.partialInvoiceCounter,
        res.consolidatedNettoAmount,
        res.taxType,
        res.showAmount,
        res.showBaseCost,
        res.showAmountGross,
        res.showBaseCostGross,
        res.showBookingText,
        res.showInformation,
        res.showPosition,
        res.showQuantity,
        res.showQuantityType,
        res.showSignature,
        res.showTaxSum,
        res.title,
        res.userPhoneNumber,
        res.deliveryTime,
        res.consolidatedDeliveryDate2 ? BackendDate(res.consolidatedDeliveryDate2) : null,
        (res.allowanceCharges as any) || [],
        (res.aRLCalculationPreChargeByType as any) || [],
        res.aRLCalculationGlobalPreCharge,
        res.skontoIsAllowance,
        res.nebenKostenPercent,
        res.employeeArlQuantityTypeId,
        res.gaebfromVersionId,
        res.gaebExportedDocumentIds as any,
        res.breakPageMode,
        res.showSalaryBaseCost,
        res.showOtherBaseCost,
        res.deliveryStreet,
        res.deliveryName,
        res.deliveryPostalCode,
        res.deliveryCity,
        res.servicePeriod,
        res.textBottomFirst,
        res.arlTableStartOnNewPage,
        res.showTextBottomFirst,
        res.useListPriceForNewMaterials,

        res.retentionPercentage,
        res.warrantyRetentionPercentage,
        res.reviewPeriodText,
        res.skontoPeriodText,

        res.closingInvoiceDiscountPeriod,
        res.closingInvoiceDuePeriod,
        res.closingInvoiceReviewPeriod,
        res.partialInvoiceDiscountPeriod,
        res.partialInvoiceDuePeriod,
        res.partialInvoiceReviewPeriod,

        res.useQuantityHistory,
        res.invoiceItems ? res.invoiceItems.map(LedgerImportInvoiceItemFromString) : [],
        res.paymentItems ? res.paymentItems.map(LedgerImportPaymentItemFromString) : [],
        res.partiestd,
        res.eventIds,
        (res.additionalData as unknown as LedgerImportAdditionalData)?.LvARLSurchargesByType, //todo in eigenes feld auslagern
        res.isLVCalculated,
        res.lVKalkulationNebenkosten ? res.lVKalkulationNebenkosten : [],
        res.lVKalkulationNebenkostenGewerke,
        res.aRLReadOnlyModeSetByUser,
        ledgerImportGaebFileTypesValues.includes(res.gabeImportedType as any) ? (res.gabeImportedType as LedgerImportGaebFileTypes) : null,
        res.showLongInformation,
        res.hideLetterHead,
        res.documentStatus,
        res.columnsNamesInDocument ? res.columnsNamesInDocument : [],
        res.deletedAt && BackendDate(res.deletedAt),
        res.useDeliveryAddressFromCommission,
        res.showSalaryBaseCost_cost,
        res.showOtherBaseCost_cost,
        res.showBaseCost_cost,
        res.showBaseCostGross_cost,
        res.taxTypeId,
        res.showQRCode,
        res.partnerAccountHolder,
        res.itemNumbersLocked,
        res.invoiceItemTableStartOnNewPage,
        res.hideSumTable,
        res.hidePositionsWithoutQuantity,
        res.customerUstId,
    );
}
export const LedgerImportInvoiceItemFromString = (i: LedgerImportType['invoiceItems'][0]): LedgerImportInvoiceItem => ({
    ...i,
    invoiceDate: i.invoiceDate && BackendDate(i.invoiceDate),
    amountBrutto: isNotNullOrUndefined(i.amountBrutto) ? financialRound(i.amountBrutto / 100) : null,
    amountNetto: isNotNullOrUndefined(i.amountNetto) ? financialRound(i.amountNetto / 100) : null,
})

export const LedgerImportInvoiceItemFromStringGrpc = (i: InvoiceItemGRPC): LedgerImportInvoiceItem => ({
    invoiceNo: i.InvoiceNo,
    ledgerImportId: +i.LedgerImportId,
    name: i.Name,
    invoiceDate: i.InvoiceDate && GetTimeFromTimestamp(+i.InvoiceDate),
    amountBrutto: isNotNullOrUndefined(i.AmountBrutto) ? financialRound(+i.AmountBrutto / 100) : null,
    amountNetto: isNotNullOrUndefined(i.AmountNetto) ? financialRound(+i.AmountNetto / 100) : null,
})

export const LedgerImportPaymentItemFromString = (i: LedgerImportType['paymentItems'][0]): LedgerImportPaymentItem => ({
    ...i,
    paymentDate: i.paymentDate && BackendDate(i.paymentDate),
    payedAmountBrutto: isNotNullOrUndefined(i.payedAmountBrutto) ? financialRound(i.payedAmountBrutto / 100) : null,
    payedAmountNetto: isNotNullOrUndefined(i.payedAmountNetto) ? financialRound(i.payedAmountNetto / 100) : null,
})

export const LedgerImportPaymentItemFromStringGrpc = (i: PaymentItemGRPC): LedgerImportPaymentItem => {
    return {
    businessVolumeId: +i.BusinessVolumeId,
    bVType: BusinessVolumeCostStateEnumGrpc.get(i.BVType),
    businessVolumeNo: i.BusinessVolumeNo,
    paymentDate: i.PaymentDate && GetTimeFromTimestamp(+i.PaymentDate),
    payedAmountBrutto: isNotNullOrUndefined(i.PayedAmountBrutto) ? financialRound(+i.PayedAmountBrutto / 100) : null,
    payedAmountNetto: isNotNullOrUndefined(i.PayedAmountNetto) ? financialRound(+i.PayedAmountNetto / 100) : null,
}
}
export const LedgerImportPaymentItemToString = (i: LedgerImportPaymentItem): LedgerImportType['paymentItems'][0] => ({
    ...i,
    paymentDate: i.paymentDate && FrontendDate(i.paymentDate),
    payedAmountBrutto: isNotNullOrUndefined(i.payedAmountBrutto) ? financialRound(i.payedAmountBrutto * 100) : null,
    payedAmountNetto: isNotNullOrUndefined(i.payedAmountNetto) ? financialRound(i.payedAmountNetto * 100) : null,
})
export const compareLedgerImportPaymentItems = (a: LedgerImportPaymentItem, b: LedgerImportPaymentItem)=> {
    return JSON.stringify(LedgerImportPaymentItemToString(a)) === JSON.stringify(LedgerImportPaymentItemToString(b));
}

export const ledgerImportTableColumnNames = {
    ConsolidatedInvoiceId: 'Nummer',
    ConsolidatedAmount: 'Summe (Brutto)',
    ConsolidatedNettoAmount: 'Summe (Netto)',
    notes: 'Notiz',
    DueDate: 'Fälligkeitsdatum',
    Type: 'Typ',
    ConsolidatedDate: 'Datum',
    CreatedAt: 'Erstellungsdatum',
}
